<h1 mat-dialog-title>{{data.text}}</h1>
<div mat-dialog-content align="center">
  <mat-form-field appearance="fill">
    <mat-label>Username</mat-label>
    <input cdkFocusInitial matInput [(ngModel)]="data.username">
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Password</mat-label>
    <input type="password" matInput [(ngModel)]="data.password">
  </mat-form-field>
</div>
<div mat-dialog-actions align="center">
  <button mat-button (click)="close()">Ok</button>
</div>